import React from 'react';
import { Modal, Button } from 'antd';

interface ConfirmationDialogProps {
    visible: boolean;
    onConfirm: () => void;
    onCancel: () => void;
    loading?: boolean;
    title?: string;
    description?: string;
    titleText?: string;
    descriptionText?: string;
    confirmText?: string;
    cancelText?: string;
    confirmDanger?: boolean;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
    visible,
    onConfirm,
    onCancel,
    loading = false,
    title = 'Are you sure?',
    description = 'Do you really want to delete this item? This action cannot be undone.',
    titleText,
    descriptionText,
    confirmText = 'Delete',
    cancelText = 'Cancel',
    confirmDanger = true,
}) => (
    <Modal
        title={titleText ?? title}
        open={visible}
        onOk={onConfirm}
        onCancel={onCancel}
        footer={[
            <Button key="cancel" onClick={onCancel}>
                {cancelText}
            </Button>,
            <Button key="confirm" type="primary" danger={confirmDanger} onClick={onConfirm} loading={loading}>
                {confirmText}
            </Button>,
        ]}
    >
        {(descriptionText ?? description) ? <p>{descriptionText ?? description}</p> : null}
    </Modal>
);

export default ConfirmationDialog;
